import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, ChangeDetectorRef, Injector } from '@angular/core';
import { BaseView } from '../base-view';
import { ChatAction, FileDto } from '../base-types';
import { ChatSettings } from './chat-settings';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import { TranslateService } from '@ngx-translate/core';
import { ChatMessage } from './chat-message';
// import { ChatList } from '../../../data/chat-list';
// import { ChatMessage } from '../../../data/chat-message';
// import { MOCK_CHAT_MESSAGES } from '../../../data/chat-messages';
// import { Contact } from '../../../data/contact';
// import { ChatDataService } from '../../../services/chat-data.service';
// import { ContactDataService } from '../../../services/contact-data.service';

export interface ParentControlledChatFields {
    workingWidth?: number,
    error?: boolean,   //Indica se si è verificato un errore nel caricamento dei dati
    loading?: boolean, //Riferito al caricamento dell'intera griglia (non solo degli items)
    loadingMoreItems?: boolean,
    successfulMessageSending?: boolean,
    messageCount?: number,
    selectionColumnShown?: boolean
}

export interface ChatEvent {
    actionChange?: 'none' | string,                                                             //the current action
    widthChange?: number,
    messageClick?: { [key: string]: number | string | boolean | (string | number)[] | File | File[] } //the selected row
    moreItemsRequest?: number //row number dell'ultimo item caricato
    checkedMessagesChange?: string[] //checked rows ids
    messageSending?:string
}

// export interface ChatList {
//     id: string;
//     contactId: string;
//     checked: boolean;
//     last: string;
//   }

//   export interface Contact{
//     dbId: string; 
//     username: string;     
//     firstName: string;     
//     unicodeFirstName: string;     
//     lastName: string;     
//     unicodeLastName: string;     
//     email: string;     
//     status: number;     
//     H323Code: string;     
//     avatarId: string;
//     checked: boolean;  
//     lastMessage: string;   
//   }



@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatComponent extends BaseView {

    get ownerId() {
        return this._ownerId;
    }

    private _ownerId: string;


    get topicName() {
        return this._topicName;
    }

    private _topicName: string;

    get successfulMessageSending() {
        return this._successfulMessageSending;
    }

    private _successfulMessageSending:boolean

    /**
   * Valori di competenza del consumer. Vengono passati alla griglia attraverso questo oggetto
   */
    @Input() set parentControlledFields(parentControlledFields: ParentControlledChatFields) {
        if (parentControlledFields) {
            //console.log('parentControlledFields :>> ', JSON.stringify(parentControlledFields));
            if (![null, undefined].includes(parentControlledFields.error))
                this._error = parentControlledFields.error;
            if (![null, undefined].includes(parentControlledFields.loading))
                this._loading = parentControlledFields.loading;
            if (![null, undefined].includes(parentControlledFields.loadingMoreItems)) {
                console.log('!!!!!!!!gridComponent - loadingMoreItems :>> ', parentControlledFields.loadingMoreItems);
                this._loadingMoreItems = parentControlledFields.loadingMoreItems;
            }
            if (![null, undefined].includes(parentControlledFields.messageCount))
                this._messageCount = parentControlledFields.messageCount;
            if (![null, undefined].includes(parentControlledFields.selectionColumnShown))
                this.toggleSelectionColumnShown()
            if (![null, undefined].includes(parentControlledFields.workingWidth)) {
                this._workingWidth = parentControlledFields.workingWidth;
                this._calcWorkingWidthUsedWidth()
            }
            if (![null, undefined].includes(parentControlledFields.successfulMessageSending)) {
                this._successfulMessageSending = null //senza questo settaggio intermedio non viene chiamato il setter 
                                                      //quando viene riconfermato lo stesso valore
                this._injector.get(ChangeDetectorRef).detectChanges();
                this._successfulMessageSending = parentControlledFields.successfulMessageSending;
                this._injector.get(ChangeDetectorRef).detectChanges();
            }
        }
    }

    @Output() eventEmission: EventEmitter<ChatEvent> = new EventEmitter<ChatEvent>();

    /**
     * Larghezza utile comunicata dal parent in modo che il componente sappia quanto spazio ha a disposizione prima di dover ricorrere allo scrolling
     */
    get workingWidth() {
        return this._workingWidth;
    }
    _workingWidth: number;

    /**
     * Larghezza totale della griglia (somma della larghezza delle singole colonne). La parte che non ci sta nella viewport diventa scrollabile
     */
    get width() {
        return this._width;
    }
    _width: number;

    /**
     * La larghezza (visibile) effettivamente occupata della larghezza utile (può essere minore o uguale alla larghezza utile, mai superiore)
     * Si parla di larghezza dell'area visibile (non conta quindi quella fuori dalla viewport)
     */
    get workingWidthUsedWidth() {
        return this._workingWidthUsedWidth;
    }
    _workingWidthUsedWidth;

    /**
     * La modalità di esecuzione di filtro e ordinamento. 
     * - Se vale 'client' filtro e ordinamento vengono effettuati all'interno dalla grid sul dataset passato in fase di inizializzazione
     * - Se vale 'server' allora la griglia si limiterà ad emettere i valori correnti di filtro e ordinamento, in modo che il consumer
     * possa ri-inizializzare la grid con un nuovo dataset, a seguito dell'applicazione dei criteri di filtro e ordinamento emessi
     * dalla grid.
     */
    get mode() {
        return this._mode;
    }
    _mode: 'client' | 'server' = 'client';

    get availableActions() {
        return this._availableActions
    }
    _availableActions: ChatAction[]


    /** Vale true se la colonna di selezione multipla è visibile
       */
    selectionColumnShown: boolean = false;

    currentAction: 'none' | string = 'none'

    /** Vale true se le righe sono visibili
     */
    messagesShown: boolean = false;

    /** vale true se si è verificato un errore nel caricamento dei dati (generalmente dovuto
     * ad un problema nella chiamata al REST). La griglia entra in uno stato in cui è necessario
     * ricaricare i dati premendo il bottone "refresh"
     */
    _error: boolean = false;
    get error() { return this._error }

    /** vale true se è in corso il caricamento della griglia (non solo degli items)
     */
    _loading: boolean = false;
    get loading() { return this._loading }

    /** vale true se ci sono degli item in corso di accodamento al dataset della griglia (infinite scroll)
     */
    _loadingMoreItems: boolean = false;
    get loadingMoreItems() { return this._loadingMoreItems }


    /** Da usare solo in caso di mode=='server'
     * Il numero di righe viene contato dal parent component e settato in input.
     */
    _messageCount: number;
    get rowCount() { return this._messageCount };

    /**
   * Numero di righe visualizzate
   */
    _size: number;
    get size() {
        return this._size;
    }

    @Input() set settings(settings: ChatSettings) {
        if (settings) {
            this._mode = settings.mode || 'client';
            //In caso di mode 'server' attiva la funzione di INFINITE SCROLL
            if (this.mode == 'server') {
                // this.scrollDispatcher.scrolled().pipe(
                //   filter(event => {
                //     console.log('this.virtualScroll.getRenderedRange() :>> ', this.virtualScroll.getRenderedRange());
                //     return this.virtualScroll.getRenderedRange().end === this.virtualScroll.getDataLength()})
                // ).subscribe(event => {
                //   console.log('new result append - loadingMoreItems? : ',this.loadingMoreItems);
                //   if(!this.loadingMoreItems)
                //     this.onMoreItemsRequest()
                // })
            }
            this._size = settings.size || 8;

            this._ownerId = settings.ownerId;

            this._topicName = settings.topicName;

            //   if(settings.availableActions) {
            //     this._availableActions = JSON.parse(JSON.stringify(settings.availableActions))
            //   }
        }
    }

    get settings(){
        return this._settings;
    }

    _settings: ChatSettings = {}


    /**
     * Righe settate dal consumer.
     * 
     * - Se mode=='client' si tratta dell'intero resultset, che verrà filtrato e ordinato direttamente sulla grid
     *   In questo caso il setter non verrà più chiamato a meno che non venga ricaricata la pagina
     * 
     * - Se mode=='server' si tratta della parte di dati già recuperati dal server (a blocchi paginati) applicando i criteri di filtro/ordinamento correnti.
     *   In questo caso il sertter verrà chiamato ogni volta che vengono cambiati un criterio di filtro o ordinamento
     *   Le rows ricevute vengono immediatamente clonate su _shownRows per popolare la grid
     */
    @Input() set messages(messages: ChatMessage[]) {
        if (messages) {
            if(JSON.stringify(messages)!=JSON.stringify(this._messages)){
                this._messages = messages;
                this._shownMessages = JSON.parse(JSON.stringify(messages));
                setTimeout(() => {
                    this.scrollToBottom();
                }, 100); //bisogna dare il tempo al setter di shownMessages di concludersi 
            }
        }
    }
    private _messages: ChatMessage[]

    /**
      * Righe visualizzate.
      * 
      * - Se mode=='client' puo' non coincidere con 'rows', perchè 'shownRows' è filtrato e ordinato
      * - Se mode=='server' coincide con 'rows'
      */
    get shownMessages() {
        return this._shownMessages;
    }
    private _shownMessages: ChatMessage[]

    get selectedMessageId() {
        return this._selectedMessageId
    }
    _selectedMessageId

    get checkedMessagesIds() {
        return this._checkedMessagesIds
    }
    _checkedMessagesIds = []

    //@ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        private scrollDispatcher: ScrollDispatcher,
        protected _translator: TranslateService,
        protected _injector: Injector) {
        super(_injector);
    }

    ngOnInit() {
    }

    messageClick = (message: ChatMessage) => {
        //this.eventEmission.emit({messageClick: message});
    }

    toggleGlobalCheck(checked: boolean) {
        // if(checked)
        //   this._checkedMessagesIds=this.shownMessages.map(el=>el.id)
        // else 
        //   this._checkedRowsIds=[]
        // this.eventEmission.emit({checkedRowsChange:this.checkedRowsIds})
    }

    modifyCheckedRowsIds(rowId, checked: boolean) {
        // if(checked)
        //   this._checkedRowsIds.push(rowId)
        // else 
        //   this._checkedRowsIds=this.checkedRowsIds.filter(el=>el!=rowId)
        // this.eventEmission.emit({checkedRowsChange:this.checkedRowsIds})
    }

    public async refresh() {
        // console.log('refresh pressed');
        // this._applyCurrentSearchCriteria();
    }

    public toggleSelectionColumnShown(currentAction?: string) {
        // if(this.selectionColumnShown) {
        //   this._checkedRowsIds=[]
        //   this._width-=40;
        //   this.eventEmission.emit({actionChange: 'none'});
        // }
        // else {
        //   this._width+=40;
        //   this.eventEmission.emit({actionChange: currentAction});
        // } 
        // this.selectionColumnShown = !this.selectionColumnShown;
        // this._calcWorkingWidthUsedWidth()
        // this.eventEmission.emit({widthChange: this.width})
    }

    /**
     * In caso di mode=='server' viene utilizzata una infinite-scroll.
     * Quando viene effettuato uno scrollDown deve essere notificato al consumer in modo che richieda al server ulteriori record
     */
    public onMoreItemsRequest() {
        // console.log('scrolled down!! - this._rows.length:', this._rows.length);
        // this.eventEmission.emit({moreItemsRequest: this._rows.length})
    }

    public onMultipleSelectionToggle(event) {
        console.log('onMultipleSelectionToggle :>> ', event);
    }

    private _calcWorkingWidthUsedWidth = () => this._workingWidthUsedWidth = this.width < this._workingWidth ? this.width : this.workingWidth


    @ViewChild('scrollableDialogueContainer') public myScrollContainer: ElementRef;

    scrollToBottom(): void {
        try {
            // console.log('offsetHeight :>> ', this.myScrollContainer.nativeElement.offsetHeight); //1093
            // console.log('clientHeight :>> ', this.myScrollContainer.nativeElement.clientHeight); //1093
            // console.log('scrollHeight :>> ', this.myScrollContainer.nativeElement.scrollHeight); //1086
            // console.log('height :>> ', this.myScrollContainer.nativeElement.height);
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }

    sendMessage = (event) => {
        console.log('sendMessage event :>> ', event);
        this.eventEmission.emit({messageSending: event})
    }

}